import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDominicanRepublic = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1958)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.41333 15.1305C1.52136 19.2415 4.75841 22.4786 8.86953 23.5867V15.1305H0.41333Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86949 0.413391C4.75841 1.52138 1.52131 4.75847 0.41333 8.86955H8.86953V0.413391H8.86949Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.5866 8.86955C22.4787 4.75847 19.2416 1.52138 15.1305 0.413391V8.86959H23.5866V8.86955Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1305 23.5866C19.2416 22.4786 22.4787 19.2415 23.5867 15.1304H15.1305V23.5866Z",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.1304 12C15.1304 13.7289 13.7289 15.1304 12 15.1304C10.2711 15.1304 8.86951 13.7289 8.86951 12C8.86951 10.2711 12 8.86954 12 8.86954C12 8.86954 15.1304 10.2711 15.1304 12Z",
				fill: "#496E2D"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.86951 12C8.86951 10.2711 10.2711 8.86954 12 8.86954C13.7289 8.86954 15.1304 10.2711 15.1304 12",
				fill: "#0052B4"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.2391 10.4348V12.3913C10.2391 13.3638 11.0275 14.1522 12 14.1522C12.9725 14.1522 13.7609 13.3638 13.7609 12.3913V10.4348H10.2391Z",
				fill: "#D80027"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1958",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgDominicanRepublic;
